import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StakeholderResponseRoutingModule } from './stakeholder-response-routing.module';
import { StakeholderResponseComponent } from './components/stakeholder-response/stakeholder-response.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EpimsDashboardNavModule } from '@cradua/epims-dashboard-nav';
import { DocumentComponent } from './components/document/document.component';
import { AngularMaterialModule } from '@cradua/material';
@NgModule({
  declarations: [StakeholderResponseComponent, DocumentComponent],
  entryComponents: [DocumentComponent],
  imports: [
    CommonModule,
    StakeholderResponseRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    EpimsDashboardNavModule,
    AngularMaterialModule,
  ],
})
export class StakeholderResponseModule {}
